/**
 * @generated SignedSource<<bb1b3cce47fd8946694e9548ea91750d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSearchForm_defaultDepartureAirport$data = {
  readonly code: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "FlightSearchForm_defaultDepartureAirport";
};
export type FlightSearchForm_defaultDepartureAirport$key = {
  readonly " $data"?: FlightSearchForm_defaultDepartureAirport$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_defaultDepartureAirport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSearchForm_defaultDepartureAirport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "type": "Airport",
  "abstractKey": null
};

(node as any).hash = "d92f8da675cd0b9a8199a78641f2b4dd";

export default node;
